"use client";

import { cn } from "@/lib/utils";
import type { QueueStats } from "@/client/hooks/useTaskQueue";

export interface TaskProgressBarProps {
  stats: QueueStats | null;
  className?: string;
}

/**
 * 任务进度条组件
 * 显示当前任务队列的状态：等待中、执行中、已完成
 */
export const TaskProgressBar = ({ stats, className }: TaskProgressBarProps) => {
  if (!stats || stats.total === 0) {
    return null;
  }

  const { queued, running, completed, total } = stats;
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;
  const pending = queued + running;

  return (
    <div className={cn("flex items-center gap-2 text-xs text-muted-foreground", className)}>
      {/* 进度条 */}
      <div className="flex-1 h-1 bg-muted rounded-full overflow-hidden min-w-[60px]">
        <div
          className="h-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
      
      {/* 完成数/总数 */}
      <span className="tabular-nums whitespace-nowrap">
        {completed}/{total}
      </span>
      
      {/* 执行中状态 */}
      {running > 0 && (
        <span className="text-primary whitespace-nowrap">
          <span className="inline-block w-1.5 h-1.5 bg-primary rounded-full animate-pulse mr-1" />
          {running} 执行中
        </span>
      )}
      
      {/* 等待中状态 */}
      {queued > 0 && running === 0 && (
        <span className="text-muted-foreground whitespace-nowrap">
          {queued} 等待中
        </span>
      )}
    </div>
  );
};
